import { render, staticRenderFns } from "./ProductOptionSetting.vue?vue&type=template&id=469dce95&scoped=true&"
import script from "./ProductOptionSetting.vue?vue&type=script&lang=js&"
export * from "./ProductOptionSetting.vue?vue&type=script&lang=js&"
import style0 from "./ProductOptionSetting.vue?vue&type=style&index=0&id=469dce95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469dce95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('469dce95')) {
      api.createRecord('469dce95', component.options)
    } else {
      api.reload('469dce95', component.options)
    }
    module.hot.accept("./ProductOptionSetting.vue?vue&type=template&id=469dce95&scoped=true&", function () {
      api.rerender('469dce95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/components/shop/ProductOptionSetting.vue"
export default component.exports